// extracted by mini-css-extract-plugin
module.exports = {"root":"RemainingBalanceDue_root__Korsh"};